import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppDependenciesModule } from './app-dependencies.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { LoginComponent } from './login/login.component';
import {AmplifyService} from 'aws-amplify-angular';
import { FormlyFieldFile } from './component/file-type.component';
import { FileValueAccessor } from './component/file-value-accessor';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent


  ],
  imports: [
    FormsModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppDependenciesModule,
    ReactiveFormsModule,
    FormlyModule.forRoot(

    ),
    FormlyBootstrapModule
  ],
  providers: [AmplifyService],
  bootstrap: [AppComponent]

})
export class AppModule { }
